import * as ActionTypes from './actions';

const warningMessages = (state = [], action) => {
	switch (action.type) {
		case ActionTypes.WARNING_MESSAGES_SUCCESS:
			return action.payload;
		default:
			return state;
	}
};

export default warningMessages;